import React, { Component } from 'react';
import toast from 'react-hot-toast';
import { Textarea, Modal } from '../../../UiKit';
import { CommentsPop } from '../../popups';

import './Comments.scss';
import { getIDParamValueFromSmartplugURL } from '../../../utils/UtilFunctionsV1';
import {
  DASHBOARD_MODE,
  SMARTPLUG_URL_PARAMS,
} from '../../../utils/UtilConstants';

const dashboardMode = window.dashboard.mode;
export default class Comments extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCommemntsPopup: false,
      textAreaVal: '',
      isActive: false,
    };
  }

  componentDidMount() {
    this.getCommentsData();
  }

  getTextareaVal(event) {
    if (event.target.value && event.target.value.length) {
      this.setState({
        textAreaVal: event.target.value,
        isActive: true,
      });
    } else {
      this.setState({
        textAreaVal: event.target.value,
        isActive: false,
      });
    }
  }

  getCommentsData = () => {
    const { getCommentsData, cartId } = this.props;
    const querryParams = {};
    querryParams['cart_id'] = cartId;
    getCommentsData(querryParams);
  };

  showCommemntsPopup = () => {
    this.setState({
      showCommemntsPopup: true,
    });
  };

  closePopup = () => {
    this.setState({
      showCommemntsPopup: false,
    });
  };

  addComments = () => {
    const { textAreaVal } = this.state;
    const { orderId, addComments } = this.props;

    const data = {
      order_id: orderId,
      comment: textAreaVal,
    };

    if (!textAreaVal?.length) return;

    if (dashboardMode === DASHBOARD_MODE.SMARTPLUG) {
      data.session_id = getIDParamValueFromSmartplugURL(
        SMARTPLUG_URL_PARAMS.UC_SESSION_ID,
      );
    }

    addComments(data)
      .then((res) => {
        if (!res || (res && res.isError === true)) {
          toast.error(res.message || 'Oooopss! something went wrong!');
          return;
        }
        toast.success('Comment successfully added!');
        this.getCommentsData();
        this.setState({
          textAreaVal: '',
          isActive: false,
        });
      })
      .catch(() => {
        toast.error('Oooopss! something went wrong!');
      });
  };

  render() {
    const { comments } = this.props;
    const { showCommemntsPopup, isActive } = this.state;
    const commentsCount = comments ? comments.length : '0';

    return (
      <div className='commentsContainer'>
        {/* {isShowShimmer ?
                    <Shimmer height="220px" width="300px" /> :  */}
        <div className='addComments col'>
          <div className='commentsHeader'>
            <h2 className='large'>Comments</h2>
            <p
              className='seeComments colorGreen'
              onClick={this.showCommemntsPopup.bind(this)}
            >
              See all ({commentsCount})
            </p>
          </div>
          <div className='commentsBox'>
            <Textarea
              value={this.state.textAreaVal}
              onChange={this.getTextareaVal.bind(this)}
              onClick={this.addComments}
              active={isActive}
              showMaxLimit={false}
            />
          </div>
        </div>
        {/* } */}
        <Modal
          isVisible={showCommemntsPopup}
          title='Comments'
          type='large'
          handleClose={this.closePopup.bind(this)}
          component={<CommentsPop comments={comments} />}
        />
      </div>
    );
  }
}
